import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TextField, FormHelperText, FormControl } from '@material-ui/core'

const FactorInput = ({ factor, setFactor }) => {
    const [error, setError] = useState(false)

    return (
        <FormControl>
            <TextField
                error={error}
                value={factor}
                onChange={(e) => {
                    const value = e.target.value.replace(',', '.')
                    if (isNaN(Number(value)) || value === '') {
                        setError(true)
                    } else {
                        setError(false)
                    }
                    setFactor(value)
                }}
            />
            <FormHelperText>Factor</FormHelperText>
        </FormControl>
    )
}

FactorInput.propTypes = {
    factor: PropTypes.any.isRequired
}

export default FactorInput
